<div>
    <app-page-breadcrumb pageTitle="Notas de Crédito / Débito" />

    <!-- ACCIONES SUPERIORES -->
    <div
        class="mb-4 flex justify-end rounded-2xl border border-gray-200 bg-white px-4 py-4 dark:border-gray-800 dark:bg-white/[0.03]">

        <button type="button"
            class="inline-flex items-center gap-2 rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white hover:bg-brand-600"
            (click)="onCreateNote()">
            + Nueva nota
        </button>

        <button type="button"
            class="ml-2 inline-flex items-center gap-2 rounded-lg bg-gray-200 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-300"
            (click)="loadNotes()" [disabled]="loadingTable">
            {{ loadingTable ? 'Actualizando…' : 'Actualizar' }}
        </button>
    </div>

    <!-- TABLA -->
    <div
        class="min-h-[60vh] rounded-2xl border border-gray-200 bg-white px-3 py-5 dark:border-gray-800 dark:bg-white/[0.03] xl:px-4 xl:py-5">

        <div class="w-full">
            <div class="rounded-2xl border border-gray-200 bg-white pt-4 dark:border-white/[0.05] dark:bg-white/[0.03]">

                <!-- HEADER TABLA -->
                <div class="flex flex-col gap-2 px-5 mb-4 sm:flex-row sm:items-center sm:justify-between sm:px-6">
                    <h3 class="text-lg font-semibold text-gray-800 dark:text-white/90">
                        Listado de notas de crédito / débito
                    </h3>

                    <div class="relative">
                        <input type="text" placeholder="Buscar por cliente o comprobante..."
                            (input)="setSearchTerm($any($event.target).value)"
                            class="dark:bg-dark-900 h-[42px] w-full rounded-lg border border-gray-300 bg-transparent py-2.5 pl-4 pr-4 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 xl:w-[300px]" />
                    </div>
                </div>

                <!-- TABLA -->
                <div class="overflow-hidden">
                    <div class="max-w-full px-5 overflow-x-auto sm:px-6">

                        <table class="w-full min-w-215">
                            <thead class="border-gray-100 border-y dark:border-white/[0.05]">
                                <tr>
                                    <th
                                        class="w-[8%] py-3 font-normal text-gray-500 text-start text-theme-sm dark:text-gray-400">
                                        Comprobante</th>
                                    <th
                                        class="w-[8%] py-3 font-normal text-gray-500 text-start text-theme-sm dark:text-gray-400">
                                        Fecha emisión</th>
                                    <th
                                        class="w-[15%] py-3 font-normal text-gray-500 text-start text-theme-sm dark:text-gray-400">
                                        Tipo</th>
                                    <th
                                        class="w-[21%] py-3 font-normal text-gray-500 text-start text-theme-sm dark:text-gray-400">
                                        <button class="inline-flex items-center gap-1 hover:text-gray-700 dark:hover:text-gray-200" (click)="toggleSort('cliente')">
                                            Cliente
                                            <svg class="w-3.5 h-3.5" [class.text-brand-500]="sortColumn === 'cliente'" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                                                @if (sortColumn === 'cliente' && sortDir === 'asc') {
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M5 15l7-7 7 7" />
                                                } @else if (sortColumn === 'cliente' && sortDir === 'desc') {
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
                                                } @else {
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M7 16V4m0 0L3 8m4-4l4 4M17 8v12m0 0l4-4m-4 4l-4-4" />
                                                }
                                            </svg>
                                        </button>
                                    </th>
                                    <th
                                        class="w-[8%] py-3 font-normal text-gray-500 text-start text-theme-sm dark:text-gray-400">
                                        Doc. Referencia</th>
                                    <th
                                        class="w-[7%] py-3 font-normal text-gray-500 text-start text-theme-sm dark:text-gray-400">
                                        Estado SUNAT</th>
                                    <th
                                        class="w-[7%] py-3 font-normal text-gray-500 text-start text-theme-sm dark:text-gray-400">
                                        Subtotal</th>
                                    <th
                                        class="w-[7%] py-3 font-normal text-gray-500 text-start text-theme-sm dark:text-gray-400">
                                        IGV</th>
                                    <th
                                        class="w-[7%] py-3 font-normal text-gray-500 text-start text-theme-sm dark:text-gray-400">
                                        Total</th>
                                    <th
                                        class="w-[12%] py-3 font-normal text-gray-500 text-start text-theme-sm dark:text-gray-400">
                                        Acciones</th>
                                </tr>
                            </thead>

                            <tbody class="divide-y divide-gray-100 dark:divide-white/[0.05]">

                                <!-- LOADING -->
                                @if (loadingTable) {
                                <tr>
                                    <td colspan="10" class="py-6 text-center text-sm text-gray-500">
                                        Cargando notas…
                                    </td>
                                </tr>
                                }

                                <!-- VACÍO -->
                                @else if (!loadingTable && notes.length === 0) {
                                <tr>
                                    <td colspan="10" class="py-6 text-center text-sm text-gray-500">
                                        No hay notas de crédito/débito registradas.
                                    </td>
                                </tr>
                                }

                                <!-- DATA -->
                                @else {
                                @for (note of currentItems; track note.id) {
                                <tr>
                                    <!-- COMPROBANTE -->
                                    <td class="py-2 text-gray-700 text-theme-sm dark:text-gray-400">
                                        {{ getNoteDoc(note) }}
                                    </td>

                                    <!-- FECHA EMISIÓN -->
                                    <td class="py-2 text-gray-700 text-theme-sm dark:text-gray-400">
                                        {{ formatDate(note.issueDate) }}
                                    </td>

                                    <!-- TIPO NC/ND -->
                                    <td class="py-3 text-sm">
                                        <app-badge size="sm"
                                            [color]="getNoteTypeBadgeColor(note.creditDebitNoteType.noteCategory)">
                                            {{ note.creditDebitNoteType.noteCategory === 'CREDITO' ? 'NC' : 'ND' }}
                                            · {{ note.creditDebitNoteType.name }}
                                        </app-badge>
                                    </td>

                                    <!-- CLIENTE -->
                                    <td class="py-2 text-gray-700 text-theme-sm dark:text-gray-400">
                                        {{ getClientName(note) }}
                                    </td>

                                    <!-- DOCUMENTO REFERENCIA -->
                                    <td class="py-2 text-gray-700 text-theme-sm dark:text-gray-400">
                                        {{ getOriginalDoc(note) }}
                                    </td>

                                    <!-- ESTADO SUNAT -->
                                    <td class="py-3 text-sm">
                                        @if (!note.series) {
                                        <span class="text-gray-400">Sin emitir</span>
                                        } @else {
                                        <div class="inline-block"
                                            (mouseenter)="showTooltip($event, note.sunatResponseCode, note.sunatMessage)"
                                            (mouseleave)="hideTooltip()">
                                            <app-badge size="sm" [color]="getStatusBadgeColor(note.status)">
                                                {{ note.status }}
                                            </app-badge>
                                        </div>
                                        }
                                    </td>

                                    <!-- SUBTOTAL -->
                                    <td class="py-2 text-gray-700 text-theme-sm dark:text-gray-400">
                                        {{ note.currencyCode === 'USD' ? '$' : 'S/' }} {{ note.subtotalAmount | number:'1.2-2' }}
                                    </td>

                                    <!-- IGV -->
                                    <td class="py-2 text-gray-700 text-theme-sm dark:text-gray-400">
                                        {{ note.currencyCode === 'USD' ? '$' : 'S/' }} {{ note.taxAmount | number:'1.2-2' }}
                                    </td>

                                    <!-- TOTAL -->
                                    <td class="py-2 text-gray-700 text-theme-sm dark:text-gray-400">
                                        {{ note.currencyCode === 'USD' ? '$' : 'S/' }} {{ note.totalAmount | number:'1.2-2' }}
                                    </td>

                                    <!-- ACCIONES -->
                                    <td class="py-2 text-gray-700 text-theme-sm dark:text-gray-400">
                                        <div class="inline-flex items-center gap-2">

                                            <button
                                                class="inline-flex items-center gap-1 bg-gray-100 hover:bg-gray-200 text-gray-700 dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-gray-200 px-3 py-1.5 rounded-md text-xs font-medium transition-colors"
                                                (click)="onViewNote(note)">
                                                <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
                                                    stroke="currentColor" stroke-width="2">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                                </svg>
                                                Detalle
                                            </button>

                                            @if (note.pdfUrl) {
                                            <button
                                                class="inline-flex items-center gap-1 bg-red-500 hover:bg-red-600 text-white px-3 py-1.5 rounded-md text-xs font-medium transition-colors"
                                                (click)="openFile(note.pdfUrl!)">
                                                <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
                                                    stroke="currentColor" stroke-width="2">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        d="M9 13h6M9 17h6M9 9h3" />
                                                </svg>
                                                PDF
                                            </button>
                                            }
                                        </div>
                                    </td>

                                </tr>
                                }
                                }

                            </tbody>
                        </table>

                    </div>
                </div>

                <!-- Pagination Controls -->
                <div class="px-6 py-4 border-t border-gray-200 dark:border-white/5">
                    <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                        <div class="flex items-center gap-2">
                            <span class="text-sm text-gray-500 dark:text-gray-400">Mostrar</span>
                            <select class="h-9 rounded-lg border border-gray-300 bg-white px-2 text-sm text-gray-700 focus:border-brand-300 focus:outline-none dark:border-gray-700 dark:bg-gray-900 dark:text-gray-300"
                                (change)="onPageSizeChange(+$any($event.target).value)">
                                @for (opt of pageSizeOptions; track opt) {
                                <option [value]="opt" [selected]="opt === itemsPerPage">{{ opt }}</option>
                                }
                            </select>
                            <span class="text-sm text-gray-500 dark:text-gray-400">registros</span>
                        </div>
                        <div class="flex items-center justify-between sm:justify-end gap-2">
                            <app-button size="sm" variant="outline" (btnClick)="goToPage(currentPage - 1)"
                                [disabled]="currentPage === 1">
                                <svg class="fill-current" width="20" height="20" viewBox="0 0 20 20" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M2.58301 9.99868C2.58272 10.1909 2.65588 10.3833 2.80249 10.53L7.79915 15.5301C8.09194 15.8231 8.56682 15.8233 8.85981 15.5305C9.15281 15.2377 9.15297 14.7629 8.86018 14.4699L5.14009 10.7472L16.6675 10.7472C17.0817 10.7472 17.4175 10.4114 17.4175 9.99715C17.4175 9.58294 17.0817 9.24715 16.6675 9.24715L5.14554 9.24715L8.86017 5.53016C9.15297 5.23717 9.15282 4.7623 8.85983 4.4695C8.56684 4.1767 8.09197 4.17685 7.79917 4.46984L2.84167 9.43049C2.68321 9.568 2.58301 9.77087 2.58301 9.99715C2.58301 9.99766 2.58301 9.99817 2.58301 9.99868Z"
                                        fill=""></path>
                                </svg>
                                <span class="hidden sm:inline">Anterior</span>
                            </app-button>
                            <span class="block text-sm font-medium text-gray-700 dark:text-gray-400 sm:hidden">
                                Pág. {{ currentPage }} / {{ totalPages }}
                            </span>
                            <ul class="hidden items-center gap-0.5 sm:flex">
                                @for (page of [].constructor(totalPages); track $index; let idx = $index) {
                                <li>
                                    <button (click)="goToPage(idx + 1)"
                                        class="flex h-10 w-10 items-center justify-center rounded-lg text-theme-sm font-medium"
                                        [ngClass]="{
                                          'bg-brand-500 text-white': currentPage === idx + 1,
                                          'text-gray-700 hover:bg-brand-500/8 dark:hover:bg-brand-500 dark:hover:text-white hover:text-brand-500 dark:text-gray-400': currentPage !== idx + 1
                                        }">
                                        {{ idx + 1 }}
                                    </button>
                                </li>
                                }
                            </ul>
                            <app-button (btnClick)="goToPage(currentPage + 1)" size="sm" variant="outline"
                                [disabled]="currentPage === totalPages">
                                <span class="hidden sm:inline">Siguiente</span>
                                <svg class="fill-current" width="20" height="20" viewBox="0 0 20 20" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M17.4175 9.9986C17.4178 10.1909 17.3446 10.3832 17.198 10.53L12.2013 15.5301C11.9085 15.8231 11.4337 15.8233 11.1407 15.5305C10.8477 15.2377 10.8475 14.7629 11.1403 14.4699L14.8604 10.7472L3.33301 10.7472C2.91879 10.7472 2.58301 10.4114 2.58301 9.99715C2.58301 9.58294 2.91879 9.24715 3.33301 9.24715L14.8549 9.24715L11.1403 5.53016C10.8475 5.23717 10.8477 4.7623 11.1407 4.4695C11.4336 4.1767 11.9085 4.17685 12.2013 4.46984L17.1588 9.43049C17.3173 9.568 17.4175 9.77087 17.4175 9.99715C17.4175 9.99763 17.4175 9.99812 17.4175 9.9986Z"
                                        fill=""></path>
                                </svg>
                            </app-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- MODAL REGISTRO/DETALLE DE NOTA -->
    <app-credit-debit-note-register [isOpen]="showForm" [selectedNote]="selectedNote" (onClose)="onCloseForm()"
        (onSaved)="handleNoteSaved()">
    </app-credit-debit-note-register>
</div>

@if (tooltipVisible) {
<div class="fixed z-9999 w-80 rounded-lg bg-gray-900 px-3 py-2 text-xs text-white shadow-lg dark:bg-gray-700 pointer-events-none"
    [style.left.px]="tooltipX"
    [style.top.px]="tooltipY - 8"
    [style.transform]="'translateY(-100%)'">
    <span class="font-semibold">{{ tooltipCode }}:</span> {{ tooltipText }}
</div>
}